import makeFetch from "../../utils/http";

export function api_getPendingAppointments(params) {
    return makeFetch(
        "appointmentRequests",
        "GET",
        params
    );
}

export function api_retrieveAppointments(params) {
    return makeFetch(
        "appointments",
        "GET",
        params
    );
}

export function api_searchAppointments(params) {
    return makeFetch(
        "appointments/search",
        "GET",
        params
    );
}
